"use client";

import Projects from "./components/Projects";
import Skills from "./components/Skills";
import AboutMe from "./components/AboutMe";
import Award from "./components/Award";
import TimeLine from "./components/TimeLine";
import Footer from "./components/Footer";
import ThemeSwitch from "./components/ThemeSwitch";
import Link from "next/link";

export default function Home() {

  return (
    <main>
      <AboutMe />
     
      <ThemeSwitch/>

      <TimeLine />
      <Projects />
      <Award />
      <Skills />
      <div>
        <div className=" px-6 py-12 md:py-15 md:px-12 max-w-7xl mx-auto">
          <div className="space-y-4">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">Quick Links</h2>
            <div className="w-20 h-1 bg-[var(--accent-cyan)] rounded-full"></div>
          </div>
          <div>
            <div className="mt-10">
              <div className="space-y-2 text-sm">
                <p>
                  <span className="font-semibold">Linkdin:</span>{" "}
                  <span className="text-blue-600 underline">
                    
                    <Link href='https://www.linkedin.com/in/imaman-gupta'>https://www.linkedin.com/in/imaman-gupta</Link>
                  </span>
                </p>
                <p>
                  <span className="font-semibold">Github:</span>{" "}
                  <span className="text-blue-600 underline">
                    <Link href='https://github.com/aman-devx'>https://github.com/aman-devx</Link>
                  </span>
                </p>
                <p>
                  <span className="font-semibold">X.com:</span>{" "}
                  <span className="text-blue-600 underline">
                    <Link href='https://x.com/amanguptax_'>https://x.com/amanguptax_</Link>
                  </span>
                </p>
                <p>
                  <span className="font-semibold">Instagram:</span>{" "}
                  <span className="text-blue-600 underline">
                     <Link href='https://www.instagram.com/amangupta0_'>https://www.instagram.com/amangupta0_</Link>
                  </span>
                </p>
                <p>
                  <span className="font-semibold">Telegram:</span>{" "}
                  <span className="text-blue-600 underline">
                    <Link href='https://t.me/amandevx'>https://t.me/amandevx</Link>
                  </span>
                </p>
                <p>
                  <span className="font-semibold">Email:</span>{" "}
                  <span className="text-blue-600 underline">
                    aman.gupta.devv@gmail.com
                  </span>
                </p>
                <p>
                  <span className="font-semibold">Phone No:</span>{" "}
                  <span className="text-blue-600">
                    +91 7972644815
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
